import './styles.scss'

import { ChangeEvent, FormEvent, ReactNode, useEffect, useState } from 'react'

import { CheckmarkIcon, PencilIcon } from '../../../assets/icons'
import * as Styled from '../styled'
import i18n from 'i18n'
import { Grid } from '@mui/material'
export interface InputWithActionProps {
  disabled?: boolean
  initialText: string
  editState: boolean
  setLoading: (b: boolean) => void
  setEditState: (b: boolean) => void
  onSubmit: (s: string) => Promise<boolean>
  nonActiveChild?: ReactNode
}

export default function InputWithAction(props: InputWithActionProps) {
  //we have 2 states of input field(edit/showing), so we keep title in the usestate
  const [title, setTitle] = useState(props.initialText)
  useEffect(() => {
    setTitle(props.initialText)
  }, [props.initialText])

  const onTitleChange = (event: ChangeEvent<HTMLInputElement>) => {
    if (event.target.value.length > 25) return
    setTitle(event.target.value)
  }

  const toggleEditName = () => {
    props.setEditState(true)
  }

  return (
    <Styled.GroupPopupInputContainer>
      {props.editState ? (
        <Styled.GroupPopupInput
          value={title}
          id="group-name-input"
          onChange={onTitleChange}
          className="title-input"
          component={
            <Styled.GroupPopupInputButton
              id="save-group-name-button"
              onClick={() => {
                props.onSubmit(title)
              }}
              type="submit"
            >
              <CheckmarkIcon />
            </Styled.GroupPopupInputButton>
          }
        />
      ) : (
        <Styled.GroupPopupName
          container
          wrap="nowrap"
          display={'flex'}
          item
          direction={'row-reverse'}
          sx={{
            overflow: 'visible',
            position: 'relative',
            zIndex: 1
          }}
        >
          <Grid
            display={'flex'}
            flexDirection={'row'}
            className="groupTitle groupTitleContainer"
            position={'relative'}
            sx={{
              overflow: 'visible',
              zIndex: 1
            }}
          >
            <span>{props.nonActiveChild ?? props.initialText}</span>
            {!props.disabled ? (
              <Styled.GroupNamePencilButton
                id="group-edit-name-button"
                sx={{
                  right: i18n.dir() === 'ltr' ? 8 : -15,
                  zIndex: 10,
                  '& .MuiTouchRipple-root': {
                    overflow: 'visible'
                  }
                }}
                size="sm"
                onClick={toggleEditName}
              >
                <PencilIcon />
              </Styled.GroupNamePencilButton>
            ) : null}
          </Grid>
        </Styled.GroupPopupName>
      )}

      {!props.disabled && props.editState ? (
        <Styled.GroupPopupInputCount>
          {25 - title.length}
        </Styled.GroupPopupInputCount>
      ) : (
        <></>
      )}
    </Styled.GroupPopupInputContainer>
  )
}
